// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Luna Point API
 * Service is intended for person cards management.
 * Version: v2.0.6
 */import {
  useMutation,
  useQuery,
  useQueryClient
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  MutationFunctionContext,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadGatewayErrorResponse,
  Card,
  CardCount,
  CardId,
  CardNotFoundResponse,
  CardToBeCreated,
  CardToBeUpdated,
  CardsToBeDeleted,
  CreateCardResponse,
  CreateFileParams,
  CreateFileResponse,
  DeleteCardsParams,
  DeleteFilesParams,
  Error,
  FaceCount,
  File,
  FileCount,
  FileNotFoundResponse,
  FileToBeUpdated,
  FilesToBeDeleted,
  ForbiddenResourceErrorResponse,
  GetCardCountParams,
  GetCardParams,
  GetCards200,
  GetCardsParams,
  GetConfig200One,
  GetFaceCountParams,
  GetFaces200,
  GetFacesParams,
  GetFileCountParams,
  GetFileParams,
  GetFiles200,
  GetFilesParams,
  GetVmsSources200,
  GetVmsSourcesParams,
  GetVmsVendorSource200,
  GetVmsVendorSourceParams,
  GetVmsVendorSources200,
  GetVmsVendorSourcesParams,
  HealthErrors,
  HealthOk,
  HealthcheckParams,
  InternalServerErrorResponse,
  LicenseProblemResponse,
  Linker,
  Plugins,
  ProxyVmsVendorSource200,
  PutFileParams,
  UpdateVmsVendorSources,
  Uuid,
  Version,
  VmsSourceNotFoundResponse,
  VmsVendorSourceToBeUpdate
} from './model';

import { pointAxiosClient } from '../axios/point-client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * get service version
 * @summary get version
 */
export const getVersion = (

 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<Version>(
      {url: `/version`, method: 'GET', signal
    },
      options);
    }




export const getGetVersionQueryKey = () => {
    return [
    `/version`
    ] as const;
    }


export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = InternalServerErrorResponse


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get version
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Create a new card.
 *
 * The card can be attached to one or several lists.
 * @summary create card
 */
export const createCard = (
    cardToBeCreated: CardToBeCreated,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<CreateCardResponse>(
      {url: `/1/cards`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: cardToBeCreated, signal
    },
      options);
    }




export const getCreateCardMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: CardToBeCreated}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: CardToBeCreated}, TContext> => {

const mutationKey = ['createCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCard>>, {data: CardToBeCreated}> = (props) => {
          const {data} = props ?? {};

          return  createCard(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateCardMutationResult = NonNullable<Awaited<ReturnType<typeof createCard>>>
    export type CreateCardMutationBody = CardToBeCreated
    export type CreateCardMutationError = Error | InternalServerErrorResponse

    /**
 * @summary create card
 */
export const useCreateCard = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCard>>, TError,{data: CardToBeCreated}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCard>>,
        TError,
        {data: CardToBeCreated},
        TContext
      > => {
      return useMutation(getCreateCardMutationOptions(options), queryClient);
    }

/**
 * Get cards according to filters.
 * @summary get cards
 */
export const getCards = (
    params?: GetCardsParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<GetCards200>(
      {url: `/1/cards`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCardsQueryKey = (params?: GetCardsParams,) => {
    return [
    `/1/cards`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCardsQueryOptions = <TData = Awaited<ReturnType<typeof getCards>>, TError = Error | InternalServerErrorResponse>(params?: GetCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCardsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCards>>> = ({ signal }) => getCards(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCardsQueryResult = NonNullable<Awaited<ReturnType<typeof getCards>>>
export type GetCardsQueryError = Error | InternalServerErrorResponse


export function useGetCards<TData = Awaited<ReturnType<typeof getCards>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetCardsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCards>>,
          TError,
          Awaited<ReturnType<typeof getCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCards<TData = Awaited<ReturnType<typeof getCards>>, TError = Error | InternalServerErrorResponse>(
 params?: GetCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCards>>,
          TError,
          Awaited<ReturnType<typeof getCards>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCards<TData = Awaited<ReturnType<typeof getCards>>, TError = Error | InternalServerErrorResponse>(
 params?: GetCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get cards
 */

export function useGetCards<TData = Awaited<ReturnType<typeof getCards>>, TError = Error | InternalServerErrorResponse>(
 params?: GetCardsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCards>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCardsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete several cards.
 * @summary delete cards
 */
export const deleteCards = (
    cardsToBeDeleted?: CardsToBeDeleted,
    params?: DeleteCardsParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<void>(
      {url: `/1/cards`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: cardsToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeleteCardsMutationOptions = <TError = Error | CardNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCards>>, TError,{data?: CardsToBeDeleted;params?: DeleteCardsParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCards>>, TError,{data?: CardsToBeDeleted;params?: DeleteCardsParams}, TContext> => {

const mutationKey = ['deleteCards'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCards>>, {data?: CardsToBeDeleted;params?: DeleteCardsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteCards(data,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteCards>>, variables: {data?: CardsToBeDeleted;params?: DeleteCardsParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteCardsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCards>>>
    export type DeleteCardsMutationBody = CardsToBeDeleted | undefined
    export type DeleteCardsMutationError = Error | CardNotFoundResponse | InternalServerErrorResponse

    /**
 * @summary delete cards
 */
export const useDeleteCards = <TError = Error | CardNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCards>>, TError,{data?: CardsToBeDeleted;params?: DeleteCardsParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCards>>,
        TError,
        {data?: CardsToBeDeleted;params?: DeleteCardsParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteCardsMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * get card count
 * @summary get card count
 */
export const getCardCount = (
    params?: GetCardCountParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<CardCount>(
      {url: `/1/cards/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCardCountQueryKey = (params?: GetCardCountParams,) => {
    return [
    `/1/cards/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCardCountQueryOptions = <TData = Awaited<ReturnType<typeof getCardCount>>, TError = Error | InternalServerErrorResponse>(params?: GetCardCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCardCount>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCardCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCardCount>>> = ({ signal }) => getCardCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCardCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCardCountQueryResult = NonNullable<Awaited<ReturnType<typeof getCardCount>>>
export type GetCardCountQueryError = Error | InternalServerErrorResponse


export function useGetCardCount<TData = Awaited<ReturnType<typeof getCardCount>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetCardCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCardCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCardCount>>,
          TError,
          Awaited<ReturnType<typeof getCardCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCardCount<TData = Awaited<ReturnType<typeof getCardCount>>, TError = Error | InternalServerErrorResponse>(
 params?: GetCardCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCardCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCardCount>>,
          TError,
          Awaited<ReturnType<typeof getCardCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCardCount<TData = Awaited<ReturnType<typeof getCardCount>>, TError = Error | InternalServerErrorResponse>(
 params?: GetCardCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCardCount>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get card count
 */

export function useGetCardCount<TData = Awaited<ReturnType<typeof getCardCount>>, TError = Error | InternalServerErrorResponse>(
 params?: GetCardCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCardCount>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCardCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Put a card.
 *
 * The card can be attached to one or several lists.
 * @summary put card
 */
export const putCard = (
    cardId: CardId,
    cardToBeCreated: CardToBeCreated,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<CreateCardResponse>(
      {url: `/1/cards/${cardId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cardToBeCreated, signal
    },
      options);
    }




export const getPutCardMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCard>>, TError,{cardId: CardId;data: CardToBeCreated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putCard>>, TError,{cardId: CardId;data: CardToBeCreated}, TContext> => {

const mutationKey = ['putCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCard>>, {cardId: CardId;data: CardToBeCreated}> = (props) => {
          const {cardId,data} = props ?? {};

          return  putCard(cardId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof putCard>>, variables: {cardId: CardId;data: CardToBeCreated}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PutCardMutationResult = NonNullable<Awaited<ReturnType<typeof putCard>>>
    export type PutCardMutationBody = CardToBeCreated
    export type PutCardMutationError = Error | InternalServerErrorResponse

    /**
 * @summary put card
 */
export const usePutCard = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCard>>, TError,{cardId: CardId;data: CardToBeCreated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCard>>,
        TError,
        {cardId: CardId;data: CardToBeCreated},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPutCardMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Check existence of the card by ID.
 * @summary check card existence
 */
export const checkCard = (
    cardId: CardId,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<void>(
      {url: `/1/cards/${cardId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckCardMutationOptions = <TError = void | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkCard>>, TError,{cardId: CardId}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkCard>>, TError,{cardId: CardId}, TContext> => {

const mutationKey = ['checkCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkCard>>, {cardId: CardId}> = (props) => {
          const {cardId} = props ?? {};

          return  checkCard(cardId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckCardMutationResult = NonNullable<Awaited<ReturnType<typeof checkCard>>>

    export type CheckCardMutationError = void | InternalServerErrorResponse

    /**
 * @summary check card existence
 */
export const useCheckCard = <TError = void | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkCard>>, TError,{cardId: CardId}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkCard>>,
        TError,
        {cardId: CardId},
        TContext
      > => {
      return useMutation(getCheckCardMutationOptions(options), queryClient);
    }

/**
 * Get card by ID.
 * @summary get card
 */
export const getCard = (
    cardId: CardId,
    params?: GetCardParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<Card>(
      {url: `/1/cards/${cardId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetCardQueryKey = (cardId: CardId,
    params?: GetCardParams,) => {
    return [
    `/1/cards/${cardId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCardQueryOptions = <TData = Awaited<ReturnType<typeof getCard>>, TError = Error | CardNotFoundResponse | InternalServerErrorResponse>(cardId: CardId,
    params?: GetCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCardQueryKey(cardId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCard>>> = ({ signal }) => getCard(cardId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: cardId !== null && cardId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCardQueryResult = NonNullable<Awaited<ReturnType<typeof getCard>>>
export type GetCardQueryError = Error | CardNotFoundResponse | InternalServerErrorResponse


export function useGetCard<TData = Awaited<ReturnType<typeof getCard>>, TError = Error | CardNotFoundResponse | InternalServerErrorResponse>(
 cardId: CardId,
    params: undefined |  GetCardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCard>>,
          TError,
          Awaited<ReturnType<typeof getCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCard<TData = Awaited<ReturnType<typeof getCard>>, TError = Error | CardNotFoundResponse | InternalServerErrorResponse>(
 cardId: CardId,
    params?: GetCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCard>>,
          TError,
          Awaited<ReturnType<typeof getCard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCard<TData = Awaited<ReturnType<typeof getCard>>, TError = Error | CardNotFoundResponse | InternalServerErrorResponse>(
 cardId: CardId,
    params?: GetCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get card
 */

export function useGetCard<TData = Awaited<ReturnType<typeof getCard>>, TError = Error | CardNotFoundResponse | InternalServerErrorResponse>(
 cardId: CardId,
    params?: GetCardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCard>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCardQueryOptions(cardId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update card fields.
 * @summary update card
 */
export const patchCard = (
    cardId: CardId,
    cardToBeUpdated: CardToBeUpdated,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<void>(
      {url: `/1/cards/${cardId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: cardToBeUpdated, signal
    },
      options);
    }




export const getPatchCardMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCard>>, TError,{cardId: CardId;data: CardToBeUpdated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCard>>, TError,{cardId: CardId;data: CardToBeUpdated}, TContext> => {

const mutationKey = ['patchCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCard>>, {cardId: CardId;data: CardToBeUpdated}> = (props) => {
          const {cardId,data} = props ?? {};

          return  patchCard(cardId,data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof patchCard>>, variables: {cardId: CardId;data: CardToBeUpdated}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetFacesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardQueryKey(variables.cardId) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type PatchCardMutationResult = NonNullable<Awaited<ReturnType<typeof patchCard>>>
    export type PatchCardMutationBody = CardToBeUpdated
    export type PatchCardMutationError = Error | InternalServerErrorResponse

    /**
 * @summary update card
 */
export const usePatchCard = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCard>>, TError,{cardId: CardId;data: CardToBeUpdated}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCard>>,
        TError,
        {cardId: CardId;data: CardToBeUpdated},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getPatchCardMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Remove card by ID.
 * @summary delete card
 */
export const deleteCard = (
    cardId: CardId,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<void>(
      {url: `/1/cards/${cardId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteCardMutationOptions = <TError = CardNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{cardId: CardId}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{cardId: CardId}, TContext> => {

const mutationKey = ['deleteCard'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCard>>, {cardId: CardId}> = (props) => {
          const {cardId} = props ?? {};

          return  deleteCard(cardId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteCard>>, variables: {cardId: CardId}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardCountQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteCardMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCard>>>

    export type DeleteCardMutationError = CardNotFoundResponse | InternalServerErrorResponse

    /**
 * @summary delete card
 */
export const useDeleteCard = <TError = CardNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCard>>, TError,{cardId: CardId}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCard>>,
        TError,
        {cardId: CardId},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteCardMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * link (or unlink) cards to a list
 * @summary link (or unlink) cards to a list
 */
export const linker = (
    linker?: Linker,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<void>(
      {url: `/1/linker`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: linker, signal
    },
      options);
    }




export const getLinkerMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linker>>, TError,{data?: Linker}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof linker>>, TError,{data?: Linker}, TContext> => {

const mutationKey = ['linker'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof linker>>, {data?: Linker}> = (props) => {
          const {data} = props ?? {};

          return  linker(data,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof linker>>, variables: {data?: Linker}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetCardsQueryKey() });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type LinkerMutationResult = NonNullable<Awaited<ReturnType<typeof linker>>>
    export type LinkerMutationBody = Linker | undefined
    export type LinkerMutationError = Error | InternalServerErrorResponse

    /**
 * @summary link (or unlink) cards to a list
 */
export const useLinker = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof linker>>, TError,{data?: Linker}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof linker>>,
        TError,
        {data?: Linker},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getLinkerMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Create a new file.
 * @summary create file
 */
export const createFile = (
    createFileBody: Blob,
    params: CreateFileParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<CreateFileResponse>(
      {url: `/1/files`, method: 'POST',
      headers: {'Content-Type': 'application/octet-stream', },
      data: createFileBody,
        params, signal
    },
      options);
    }




export const getCreateFileMutationOptions = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFile>>, TError,{data: Blob;params: CreateFileParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof createFile>>, TError,{data: Blob;params: CreateFileParams}, TContext> => {

const mutationKey = ['createFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFile>>, {data: Blob;params: CreateFileParams}> = (props) => {
          const {data,params} = props ?? {};

          return  createFile(data,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof createFile>>, variables: {data: Blob;params: CreateFileParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetFilesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetFileCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardQueryKey(variables.params?.card_id) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type CreateFileMutationResult = NonNullable<Awaited<ReturnType<typeof createFile>>>
    export type CreateFileMutationBody = Blob
    export type CreateFileMutationError = Error | LicenseProblemResponse | InternalServerErrorResponse

    /**
 * @summary create file
 */
export const useCreateFile = <TError = Error | LicenseProblemResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFile>>, TError,{data: Blob;params: CreateFileParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createFile>>,
        TError,
        {data: Blob;params: CreateFileParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getCreateFileMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get files according to filters.
 * @summary get files
 */
export const getFiles = (
    params?: GetFilesParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<GetFiles200>(
      {url: `/1/files`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFilesQueryKey = (params?: GetFilesParams,) => {
    return [
    `/1/files`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFilesQueryOptions = <TData = Awaited<ReturnType<typeof getFiles>>, TError = Error | InternalServerErrorResponse>(params?: GetFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFilesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFiles>>> = ({ signal }) => getFiles(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFilesQueryResult = NonNullable<Awaited<ReturnType<typeof getFiles>>>
export type GetFilesQueryError = Error | InternalServerErrorResponse


export function useGetFiles<TData = Awaited<ReturnType<typeof getFiles>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetFilesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiles>>,
          TError,
          Awaited<ReturnType<typeof getFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiles<TData = Awaited<ReturnType<typeof getFiles>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFiles>>,
          TError,
          Awaited<ReturnType<typeof getFiles>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFiles<TData = Awaited<ReturnType<typeof getFiles>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get files
 */

export function useGetFiles<TData = Awaited<ReturnType<typeof getFiles>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFilesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFiles>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFilesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Delete several files.
 * @summary delete files
 */
export const deleteFiles = (
    filesToBeDeleted?: FilesToBeDeleted,
    params?: DeleteFilesParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<void>(
      {url: `/1/files`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: filesToBeDeleted,
        params, signal
    },
      options);
    }




export const getDeleteFilesMutationOptions = <TError = Error | FileNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFiles>>, TError,{data?: FilesToBeDeleted;params?: DeleteFilesParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFiles>>, TError,{data?: FilesToBeDeleted;params?: DeleteFilesParams}, TContext> => {

const mutationKey = ['deleteFiles'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFiles>>, {data?: FilesToBeDeleted;params?: DeleteFilesParams}> = (props) => {
          const {data,params} = props ?? {};

          return  deleteFiles(data,params,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteFiles>>, variables: {data?: FilesToBeDeleted;params?: DeleteFilesParams}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetFilesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetFileCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardQueryKey(variables.params?.card_id) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteFilesMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFiles>>>
    export type DeleteFilesMutationBody = FilesToBeDeleted | undefined
    export type DeleteFilesMutationError = Error | FileNotFoundResponse | InternalServerErrorResponse

    /**
 * @summary delete files
 */
export const useDeleteFiles = <TError = Error | FileNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFiles>>, TError,{data?: FilesToBeDeleted;params?: DeleteFilesParams}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFiles>>,
        TError,
        {data?: FilesToBeDeleted;params?: DeleteFilesParams},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteFilesMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * get file count
 * @summary get file count
 */
export const getFileCount = (
    params?: GetFileCountParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<FileCount>(
      {url: `/1/files/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFileCountQueryKey = (params?: GetFileCountParams,) => {
    return [
    `/1/files/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFileCountQueryOptions = <TData = Awaited<ReturnType<typeof getFileCount>>, TError = Error | InternalServerErrorResponse>(params?: GetFileCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileCount>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFileCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFileCount>>> = ({ signal }) => getFileCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFileCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFileCountQueryResult = NonNullable<Awaited<ReturnType<typeof getFileCount>>>
export type GetFileCountQueryError = Error | InternalServerErrorResponse


export function useGetFileCount<TData = Awaited<ReturnType<typeof getFileCount>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetFileCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileCount>>,
          TError,
          Awaited<ReturnType<typeof getFileCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFileCount<TData = Awaited<ReturnType<typeof getFileCount>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFileCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFileCount>>,
          TError,
          Awaited<ReturnType<typeof getFileCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFileCount<TData = Awaited<ReturnType<typeof getFileCount>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFileCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileCount>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get file count
 */

export function useGetFileCount<TData = Awaited<ReturnType<typeof getFileCount>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFileCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFileCount>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFileCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Put file.
 * @summary put file
 */
export const putFile = (
    fileId: Uuid,
    putFileBody: Blob,
    params?: PutFileParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<CreateFileResponse>(
      {url: `/1/files/${fileId}`, method: 'PUT',
      headers: {'Content-Type': 'application/octet-stream', },
      data: putFileBody,
        params, signal
    },
      options);
    }




export const getPutFileMutationOptions = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFile>>, TError,{fileId: Uuid;data: Blob;params?: PutFileParams}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof putFile>>, TError,{fileId: Uuid;data: Blob;params?: PutFileParams}, TContext> => {

const mutationKey = ['putFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putFile>>, {fileId: Uuid;data: Blob;params?: PutFileParams}> = (props) => {
          const {fileId,data,params} = props ?? {};

          return  putFile(fileId,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutFileMutationResult = NonNullable<Awaited<ReturnType<typeof putFile>>>
    export type PutFileMutationBody = Blob
    export type PutFileMutationError = Error | InternalServerErrorResponse

    /**
 * @summary put file
 */
export const usePutFile = <TError = Error | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putFile>>, TError,{fileId: Uuid;data: Blob;params?: PutFileParams}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putFile>>,
        TError,
        {fileId: Uuid;data: Blob;params?: PutFileParams},
        TContext
      > => {
      return useMutation(getPutFileMutationOptions(options), queryClient);
    }

/**
 * Get file by ID.
 * @summary get file
 */
export const getFile = (
    fileId: Uuid,
    params?: GetFileParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<File>(
      {url: `/1/files/${fileId}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFileQueryKey = (fileId: Uuid,
    params?: GetFileParams,) => {
    return [
    `/1/files/${fileId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFileQueryOptions = <TData = Awaited<ReturnType<typeof getFile>>, TError = Error | FileNotFoundResponse | InternalServerErrorResponse>(fileId: Uuid,
    params?: GetFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFileQueryKey(fileId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFile>>> = ({ signal }) => getFile(fileId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: fileId !== null && fileId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFileQueryResult = NonNullable<Awaited<ReturnType<typeof getFile>>>
export type GetFileQueryError = Error | FileNotFoundResponse | InternalServerErrorResponse


export function useGetFile<TData = Awaited<ReturnType<typeof getFile>>, TError = Error | FileNotFoundResponse | InternalServerErrorResponse>(
 fileId: Uuid,
    params: undefined |  GetFileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFile>>,
          TError,
          Awaited<ReturnType<typeof getFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFile<TData = Awaited<ReturnType<typeof getFile>>, TError = Error | FileNotFoundResponse | InternalServerErrorResponse>(
 fileId: Uuid,
    params?: GetFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFile>>,
          TError,
          Awaited<ReturnType<typeof getFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFile<TData = Awaited<ReturnType<typeof getFile>>, TError = Error | FileNotFoundResponse | InternalServerErrorResponse>(
 fileId: Uuid,
    params?: GetFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get file
 */

export function useGetFile<TData = Awaited<ReturnType<typeof getFile>>, TError = Error | FileNotFoundResponse | InternalServerErrorResponse>(
 fileId: Uuid,
    params?: GetFileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFileQueryOptions(fileId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Check existence of the file by ID.
 * @summary check file existence
 */
export const checkFile = (
    fileId: Uuid,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<void>(
      {url: `/1/files/${fileId}`, method: 'HEAD', signal
    },
      options);
    }




export const getCheckFileMutationOptions = <TError = void | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkFile>>, TError,{fileId: Uuid}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof checkFile>>, TError,{fileId: Uuid}, TContext> => {

const mutationKey = ['checkFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof checkFile>>, {fileId: Uuid}> = (props) => {
          const {fileId} = props ?? {};

          return  checkFile(fileId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CheckFileMutationResult = NonNullable<Awaited<ReturnType<typeof checkFile>>>

    export type CheckFileMutationError = void | InternalServerErrorResponse

    /**
 * @summary check file existence
 */
export const useCheckFile = <TError = void | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof checkFile>>, TError,{fileId: Uuid}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof checkFile>>,
        TError,
        {fileId: Uuid},
        TContext
      > => {
      return useMutation(getCheckFileMutationOptions(options), queryClient);
    }

/**
 * Update file fields: *filename*, *mimetype*.
 * @summary update file
 */
export const patchFile = (
    fileId: Uuid,
    fileToBeUpdated: FileToBeUpdated,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<void>(
      {url: `/1/files/${fileId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fileToBeUpdated, signal
    },
      options);
    }




export const getPatchFileMutationOptions = <TError = Error | FileNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchFile>>, TError,{fileId: Uuid;data: FileToBeUpdated}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchFile>>, TError,{fileId: Uuid;data: FileToBeUpdated}, TContext> => {

const mutationKey = ['patchFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchFile>>, {fileId: Uuid;data: FileToBeUpdated}> = (props) => {
          const {fileId,data} = props ?? {};

          return  patchFile(fileId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchFileMutationResult = NonNullable<Awaited<ReturnType<typeof patchFile>>>
    export type PatchFileMutationBody = FileToBeUpdated
    export type PatchFileMutationError = Error | FileNotFoundResponse | InternalServerErrorResponse

    /**
 * @summary update file
 */
export const usePatchFile = <TError = Error | FileNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchFile>>, TError,{fileId: Uuid;data: FileToBeUpdated}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchFile>>,
        TError,
        {fileId: Uuid;data: FileToBeUpdated},
        TContext
      > => {
      return useMutation(getPatchFileMutationOptions(options), queryClient);
    }

/**
 * Remove file by ID.
 * @summary delete file
 */
export const deleteFile = (
    fileId: Uuid,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<void>(
      {url: `/1/files/${fileId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteFileMutationOptions = <TError = FileNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(queryClient: QueryClient, options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFile>>, TError,{fileId: Uuid}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteFile>>, TError,{fileId: Uuid}, TContext> => {

const mutationKey = ['deleteFile'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteFile>>, {fileId: Uuid}> = (props) => {
          const {fileId} = props ?? {};

          return  deleteFile(fileId,requestOptions)
        }

  const onSuccess = (data: Awaited<ReturnType<typeof deleteFile>>, variables: {fileId: Uuid}, onMutateResult: TContext, context: MutationFunctionContext) => {
        if (!options?.skipInvalidation) {
        queryClient.invalidateQueries({ queryKey: getGetFilesQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetFileCountQueryKey() });
    queryClient.invalidateQueries({ queryKey: getGetCardQueryKey(variables.params?.card_id) });
        }
        mutationOptions?.onSuccess?.(data, variables, onMutateResult, context);
      };




  return  { ...mutationOptions, mutationFn, onSuccess }}

    export type DeleteFileMutationResult = NonNullable<Awaited<ReturnType<typeof deleteFile>>>

    export type DeleteFileMutationError = FileNotFoundResponse | InternalServerErrorResponse

    /**
 * @summary delete file
 */
export const useDeleteFile = <TError = FileNotFoundResponse | InternalServerErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteFile>>, TError,{fileId: Uuid}, TContext>, skipInvalidation?: boolean, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteFile>>,
        TError,
        {fileId: Uuid},
        TContext
      > => {
      const backupQueryClient = useQueryClient();
      return useMutation(getDeleteFileMutationOptions(queryClient ?? backupQueryClient, options), queryClient);
    }

/**
 * Get faces according to filters.
 * @summary get faces
 */
export const getFaces = (
    params?: GetFacesParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<GetFaces200>(
      {url: `/1/faces`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFacesQueryKey = (params?: GetFacesParams,) => {
    return [
    `/1/faces`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFacesQueryOptions = <TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | InternalServerErrorResponse>(params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFacesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFaces>>> = ({ signal }) => getFaces(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFacesQueryResult = NonNullable<Awaited<ReturnType<typeof getFaces>>>
export type GetFacesQueryError = Error | InternalServerErrorResponse


export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetFacesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaces>>,
          TError,
          Awaited<ReturnType<typeof getFaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaces>>,
          TError,
          Awaited<ReturnType<typeof getFaces>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get faces
 */

export function useGetFaces<TData = Awaited<ReturnType<typeof getFaces>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFacesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaces>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFacesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * get face count
 * @summary get face count
 */
export const getFaceCount = (
    params?: GetFaceCountParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<FaceCount>(
      {url: `/1/faces/count`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetFaceCountQueryKey = (params?: GetFaceCountParams,) => {
    return [
    `/1/faces/count`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetFaceCountQueryOptions = <TData = Awaited<ReturnType<typeof getFaceCount>>, TError = Error | InternalServerErrorResponse>(params?: GetFaceCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceCount>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFaceCountQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFaceCount>>> = ({ signal }) => getFaceCount(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFaceCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFaceCountQueryResult = NonNullable<Awaited<ReturnType<typeof getFaceCount>>>
export type GetFaceCountQueryError = Error | InternalServerErrorResponse


export function useGetFaceCount<TData = Awaited<ReturnType<typeof getFaceCount>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetFaceCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceCount>>,
          TError,
          Awaited<ReturnType<typeof getFaceCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceCount<TData = Awaited<ReturnType<typeof getFaceCount>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFaceCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFaceCount>>,
          TError,
          Awaited<ReturnType<typeof getFaceCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFaceCount<TData = Awaited<ReturnType<typeof getFaceCount>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFaceCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceCount>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get face count
 */

export function useGetFaceCount<TData = Awaited<ReturnType<typeof getFaceCount>>, TError = Error | InternalServerErrorResponse>(
 params?: GetFaceCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFaceCount>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFaceCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get vms sources according to filters.
 * @summary get registered vms sources
 */
export const getVmsSources = (
    params?: GetVmsSourcesParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<GetVmsSources200>(
      {url: `/1/vms/sources`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetVmsSourcesQueryKey = (params?: GetVmsSourcesParams,) => {
    return [
    `/1/vms/sources`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetVmsSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getVmsSources>>, TError = Error | InternalServerErrorResponse>(params?: GetVmsSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsSources>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVmsSourcesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVmsSources>>> = ({ signal }) => getVmsSources(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVmsSources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVmsSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getVmsSources>>>
export type GetVmsSourcesQueryError = Error | InternalServerErrorResponse


export function useGetVmsSources<TData = Awaited<ReturnType<typeof getVmsSources>>, TError = Error | InternalServerErrorResponse>(
 params: undefined |  GetVmsSourcesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsSources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVmsSources>>,
          TError,
          Awaited<ReturnType<typeof getVmsSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVmsSources<TData = Awaited<ReturnType<typeof getVmsSources>>, TError = Error | InternalServerErrorResponse>(
 params?: GetVmsSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsSources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVmsSources>>,
          TError,
          Awaited<ReturnType<typeof getVmsSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVmsSources<TData = Awaited<ReturnType<typeof getVmsSources>>, TError = Error | InternalServerErrorResponse>(
 params?: GetVmsSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsSources>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get registered vms sources
 */

export function useGetVmsSources<TData = Awaited<ReturnType<typeof getVmsSources>>, TError = Error | InternalServerErrorResponse>(
 params?: GetVmsSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsSources>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVmsSourcesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get vms vendor sources according to filters.
 * @summary Get registered vms vendor sources
 */
export const getVmsVendorSources = (
    vendor: string & unknown,
    params?: GetVmsVendorSourcesParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<GetVmsVendorSources200>(
      {url: `/1/vms/${vendor}/sources`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetVmsVendorSourcesQueryKey = (vendor: string & unknown,
    params?: GetVmsVendorSourcesParams,) => {
    return [
    `/1/vms/${vendor}/sources`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetVmsVendorSourcesQueryOptions = <TData = Awaited<ReturnType<typeof getVmsVendorSources>>, TError = Error | InternalServerErrorResponse | BadGatewayErrorResponse>(vendor: string & unknown,
    params?: GetVmsVendorSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSources>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVmsVendorSourcesQueryKey(vendor,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVmsVendorSources>>> = ({ signal }) => getVmsVendorSources(vendor,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: vendor !== null && vendor !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSources>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVmsVendorSourcesQueryResult = NonNullable<Awaited<ReturnType<typeof getVmsVendorSources>>>
export type GetVmsVendorSourcesQueryError = Error | InternalServerErrorResponse | BadGatewayErrorResponse


export function useGetVmsVendorSources<TData = Awaited<ReturnType<typeof getVmsVendorSources>>, TError = Error | InternalServerErrorResponse | BadGatewayErrorResponse>(
 vendor: string & unknown,
    params: undefined |  GetVmsVendorSourcesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSources>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVmsVendorSources>>,
          TError,
          Awaited<ReturnType<typeof getVmsVendorSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVmsVendorSources<TData = Awaited<ReturnType<typeof getVmsVendorSources>>, TError = Error | InternalServerErrorResponse | BadGatewayErrorResponse>(
 vendor: string & unknown,
    params?: GetVmsVendorSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSources>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVmsVendorSources>>,
          TError,
          Awaited<ReturnType<typeof getVmsVendorSources>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVmsVendorSources<TData = Awaited<ReturnType<typeof getVmsVendorSources>>, TError = Error | InternalServerErrorResponse | BadGatewayErrorResponse>(
 vendor: string & unknown,
    params?: GetVmsVendorSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSources>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get registered vms vendor sources
 */

export function useGetVmsVendorSources<TData = Awaited<ReturnType<typeof getVmsVendorSources>>, TError = Error | InternalServerErrorResponse | BadGatewayErrorResponse>(
 vendor: string & unknown,
    params?: GetVmsVendorSourcesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSources>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVmsVendorSourcesQueryOptions(vendor,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update list of vendor sources.
 * @summary Update list of vendor sources
 */
export const updateVmsVendorSources = (
    vendor: string & unknown,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<UpdateVmsVendorSources>(
      {url: `/1/vms/${vendor}/sources/update`, method: 'POST', signal
    },
      options);
    }




export const getUpdateVmsVendorSourcesMutationOptions = <TError = Error | BadGatewayErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVmsVendorSources>>, TError,{vendor: string & unknown}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof updateVmsVendorSources>>, TError,{vendor: string & unknown}, TContext> => {

const mutationKey = ['updateVmsVendorSources'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVmsVendorSources>>, {vendor: string & unknown}> = (props) => {
          const {vendor} = props ?? {};

          return  updateVmsVendorSources(vendor,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVmsVendorSourcesMutationResult = NonNullable<Awaited<ReturnType<typeof updateVmsVendorSources>>>

    export type UpdateVmsVendorSourcesMutationError = Error | BadGatewayErrorResponse

    /**
 * @summary Update list of vendor sources
 */
export const useUpdateVmsVendorSources = <TError = Error | BadGatewayErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVmsVendorSources>>, TError,{vendor: string & unknown}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateVmsVendorSources>>,
        TError,
        {vendor: string & unknown},
        TContext
      > => {
      return useMutation(getUpdateVmsVendorSourcesMutationOptions(options), queryClient);
    }

/**
 * Get vms vendor source according to filters.
 * @summary Get registered vms vendor source
 */
export const getVmsVendorSource = (
    vendor: string & unknown,
    vendorUuid: string,
    params?: GetVmsVendorSourceParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<GetVmsVendorSource200>(
      {url: `/1/vms/${vendor}/sources/${vendorUuid}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetVmsVendorSourceQueryKey = (vendor: string & unknown,
    vendorUuid: string,
    params?: GetVmsVendorSourceParams,) => {
    return [
    `/1/vms/${vendor}/sources/${vendorUuid}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetVmsVendorSourceQueryOptions = <TData = Awaited<ReturnType<typeof getVmsVendorSource>>, TError = Error | InternalServerErrorResponse>(vendor: string & unknown,
    vendorUuid: string,
    params?: GetVmsVendorSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSource>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVmsVendorSourceQueryKey(vendor,vendorUuid,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVmsVendorSource>>> = ({ signal }) => getVmsVendorSource(vendor,vendorUuid,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: vendor !== null && vendor !== undefined && vendorUuid !== null && vendorUuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVmsVendorSourceQueryResult = NonNullable<Awaited<ReturnType<typeof getVmsVendorSource>>>
export type GetVmsVendorSourceQueryError = Error | InternalServerErrorResponse


export function useGetVmsVendorSource<TData = Awaited<ReturnType<typeof getVmsVendorSource>>, TError = Error | InternalServerErrorResponse>(
 vendor: string & unknown,
    vendorUuid: string,
    params: undefined |  GetVmsVendorSourceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSource>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVmsVendorSource>>,
          TError,
          Awaited<ReturnType<typeof getVmsVendorSource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVmsVendorSource<TData = Awaited<ReturnType<typeof getVmsVendorSource>>, TError = Error | InternalServerErrorResponse>(
 vendor: string & unknown,
    vendorUuid: string,
    params?: GetVmsVendorSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSource>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVmsVendorSource>>,
          TError,
          Awaited<ReturnType<typeof getVmsVendorSource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVmsVendorSource<TData = Awaited<ReturnType<typeof getVmsVendorSource>>, TError = Error | InternalServerErrorResponse>(
 vendor: string & unknown,
    vendorUuid: string,
    params?: GetVmsVendorSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSource>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get registered vms vendor source
 */

export function useGetVmsVendorSource<TData = Awaited<ReturnType<typeof getVmsVendorSource>>, TError = Error | InternalServerErrorResponse>(
 vendor: string & unknown,
    vendorUuid: string,
    params?: GetVmsVendorSourceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVmsVendorSource>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVmsVendorSourceQueryOptions(vendor,vendorUuid,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Update luna name for registered vendor source.
 * @summary Update luna name for registered vendor source
 */
export const patchVmsVendorSource = (
    vendor: string & unknown,
    vendorUuid: string,
    vmsVendorSourceToBeUpdate?: VmsVendorSourceToBeUpdate,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<void>(
      {url: `/1/vms/${vendor}/sources/${vendorUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: vmsVendorSourceToBeUpdate, signal
    },
      options);
    }




export const getPatchVmsVendorSourceMutationOptions = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchVmsVendorSource>>, TError,{vendor: string & unknown;vendorUuid: string;data?: VmsVendorSourceToBeUpdate}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
): UseMutationOptions<Awaited<ReturnType<typeof patchVmsVendorSource>>, TError,{vendor: string & unknown;vendorUuid: string;data?: VmsVendorSourceToBeUpdate}, TContext> => {

const mutationKey = ['patchVmsVendorSource'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchVmsVendorSource>>, {vendor: string & unknown;vendorUuid: string;data?: VmsVendorSourceToBeUpdate}> = (props) => {
          const {vendor,vendorUuid,data} = props ?? {};

          return  patchVmsVendorSource(vendor,vendorUuid,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchVmsVendorSourceMutationResult = NonNullable<Awaited<ReturnType<typeof patchVmsVendorSource>>>
    export type PatchVmsVendorSourceMutationBody = VmsVendorSourceToBeUpdate | undefined
    export type PatchVmsVendorSourceMutationError = Error

    /**
 * @summary Update luna name for registered vendor source
 */
export const usePatchVmsVendorSource = <TError = Error,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchVmsVendorSource>>, TError,{vendor: string & unknown;vendorUuid: string;data?: VmsVendorSourceToBeUpdate}, TContext>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchVmsVendorSource>>,
        TError,
        {vendor: string & unknown;vendorUuid: string;data?: VmsVendorSourceToBeUpdate},
        TContext
      > => {
      return useMutation(getPatchVmsVendorSourceMutationOptions(options), queryClient);
    }

/**
 * Proxy client request to vms. Response may vary depending on vms.
 * @summary Proxy client request to vms
 */
export const proxyVmsVendorSource = (
    vendor: string & unknown,
    vendorUuid: string,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<ProxyVmsVendorSource200>(
      {url: `/1/vms/${vendor}/sources/${vendorUuid}/proxy`, method: 'GET', signal
    },
      options);
    }




export const getProxyVmsVendorSourceQueryKey = (vendor: string & unknown,
    vendorUuid: string,) => {
    return [
    `/1/vms/${vendor}/sources/${vendorUuid}/proxy`
    ] as const;
    }


export const getProxyVmsVendorSourceQueryOptions = <TData = Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError = VmsSourceNotFoundResponse | InternalServerErrorResponse | BadGatewayErrorResponse>(vendor: string & unknown,
    vendorUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProxyVmsVendorSourceQueryKey(vendor,vendorUuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proxyVmsVendorSource>>> = ({ signal }) => proxyVmsVendorSource(vendor,vendorUuid, requestOptions, signal);





   return  { queryKey, queryFn, enabled: vendor !== null && vendor !== undefined && vendorUuid !== null && vendorUuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProxyVmsVendorSourceQueryResult = NonNullable<Awaited<ReturnType<typeof proxyVmsVendorSource>>>
export type ProxyVmsVendorSourceQueryError = VmsSourceNotFoundResponse | InternalServerErrorResponse | BadGatewayErrorResponse


export function useProxyVmsVendorSource<TData = Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError = VmsSourceNotFoundResponse | InternalServerErrorResponse | BadGatewayErrorResponse>(
 vendor: string & unknown,
    vendorUuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proxyVmsVendorSource>>,
          TError,
          Awaited<ReturnType<typeof proxyVmsVendorSource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProxyVmsVendorSource<TData = Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError = VmsSourceNotFoundResponse | InternalServerErrorResponse | BadGatewayErrorResponse>(
 vendor: string & unknown,
    vendorUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proxyVmsVendorSource>>,
          TError,
          Awaited<ReturnType<typeof proxyVmsVendorSource>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProxyVmsVendorSource<TData = Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError = VmsSourceNotFoundResponse | InternalServerErrorResponse | BadGatewayErrorResponse>(
 vendor: string & unknown,
    vendorUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Proxy client request to vms
 */

export function useProxyVmsVendorSource<TData = Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError = VmsSourceNotFoundResponse | InternalServerErrorResponse | BadGatewayErrorResponse>(
 vendor: string & unknown,
    vendorUuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proxyVmsVendorSource>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProxyVmsVendorSourceQueryOptions(vendor,vendorUuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get service OpenApi documentation. If *Accept* request header is of type `application/x-yaml`,
 * returns documentation in `yaml` format or returns `html` documentation, if *Accept-Type* is `text/html`
 * @summary get openapi documentation
 */
export const getSpec = (

 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<string>(
      {url: `/1/docs/spec`, method: 'GET', signal
    },
      options);
    }




export const getGetSpecQueryKey = () => {
    return [
    `/1/docs/spec`
    ] as const;
    }


export const getGetSpecQueryOptions = <TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSpecQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSpec>>> = ({ signal }) => getSpec(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSpecQueryResult = NonNullable<Awaited<ReturnType<typeof getSpec>>>
export type GetSpecQueryError = Error | InternalServerErrorResponse


export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpec>>,
          TError,
          Awaited<ReturnType<typeof getSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSpec>>,
          TError,
          Awaited<ReturnType<typeof getSpec>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get openapi documentation
 */

export function useGetSpec<TData = Awaited<ReturnType<typeof getSpec>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSpec>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSpecQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get service configuration. Passwords and tokens will be hidden in the response.
 * @summary get service configuration
 */
export const getConfig = (

 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<GetConfig200One | string>(
      {url: `/1/config`, method: 'GET', signal
    },
      options);
    }




export const getGetConfigQueryKey = () => {
    return [
    `/1/config`
    ] as const;
    }


export const getGetConfigQueryOptions = <TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConfigQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConfig>>> = ({ signal }) => getConfig(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getConfig>>>
export type GetConfigQueryError = Error | InternalServerErrorResponse


export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConfig>>,
          TError,
          Awaited<ReturnType<typeof getConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get service configuration
 */

export function useGetConfig<TData = Awaited<ReturnType<typeof getConfig>>, TError = Error | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConfig>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * get health of service
 * @summary get health
 */
export const healthcheck = (
    params?: HealthcheckParams,
 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<HealthOk>(
      {url: `/healthcheck`, method: 'GET',
        params, signal
    },
      options);
    }




export const getHealthcheckQueryKey = (params?: HealthcheckParams,) => {
    return [
    `/healthcheck`, ...(params ? [params] : [])
    ] as const;
    }


export const getHealthcheckQueryOptions = <TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | HealthErrors>(params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthcheckQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthcheck>>> = ({ signal }) => healthcheck(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type HealthcheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthcheck>>>
export type HealthcheckQueryError = InternalServerErrorResponse | HealthErrors


export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | HealthErrors>(
 params: undefined |  HealthcheckParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheck>>,
          TError,
          Awaited<ReturnType<typeof healthcheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | HealthErrors>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthcheck>>,
          TError,
          Awaited<ReturnType<typeof healthcheck>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | HealthErrors>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get health
 */

export function useHealthcheck<TData = Awaited<ReturnType<typeof healthcheck>>, TError = InternalServerErrorResponse | HealthErrors>(
 params?: HealthcheckParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof healthcheck>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHealthcheckQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get list of service plugins
 * @summary get list of plugins
 */
export const getPlugins = (

 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<Plugins>(
      {url: `/1/plugins`, method: 'GET', signal
    },
      options);
    }




export const getGetPluginsQueryKey = () => {
    return [
    `/1/plugins`
    ] as const;
    }


export const getGetPluginsQueryOptions = <TData = Awaited<ReturnType<typeof getPlugins>>, TError = InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPluginsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlugins>>> = ({ signal }) => getPlugins(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPluginsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlugins>>>
export type GetPluginsQueryError = InternalServerErrorResponse


export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlugins>>,
          TError,
          Awaited<ReturnType<typeof getPlugins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlugins>>,
          TError,
          Awaited<ReturnType<typeof getPlugins>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get list of plugins
 */

export function useGetPlugins<TData = Awaited<ReturnType<typeof getPlugins>>, TError = InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPlugins>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPluginsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







/**
 * Get statistics of success and failed requests to the service in prometheus format.
 * @summary get service requests statistics
 */
export const metrics = (

 options?: SecondParameter<typeof pointAxiosClient>,signal?: AbortSignal
) => {


      return pointAxiosClient<string>(
      {url: `/metrics`, method: 'GET', signal
    },
      options);
    }




export const getMetricsQueryKey = () => {
    return [
    `/metrics`
    ] as const;
    }


export const getMetricsQueryOptions = <TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | InternalServerErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof metrics>>> = ({ signal }) => metrics(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetricsQueryResult = NonNullable<Awaited<ReturnType<typeof metrics>>>
export type MetricsQueryError = ForbiddenResourceErrorResponse | InternalServerErrorResponse


export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | InternalServerErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metrics>>,
          TError,
          Awaited<ReturnType<typeof metrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metrics>>,
          TError,
          Awaited<ReturnType<typeof metrics>>
        > , 'initialData'
      >, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary get service requests statistics
 */

export function useMetrics<TData = Awaited<ReturnType<typeof metrics>>, TError = ForbiddenResourceErrorResponse | InternalServerErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metrics>>, TError, TData>>, request?: SecondParameter<typeof pointAxiosClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetricsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}







